var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.126 17.5972V9.47217",
    stroke: "#002C50",
    strokeWidth: 1.52349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0547 9.26316C22.0547 8.17998 24.0461 4.53369 24.0461 4.53369C24.0461 4.53369 26.0375 8.18313 26.0375 9.26316C26.0375 10.3432 25.1457 11.2249 24.0461 11.2249C22.9465 11.2249 22.0547 10.3463 22.0547 9.26316Z",
    fill: "#E52326"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.789 32.0081C13.0839 30.6629 11.9469 28.5068 13.372 26.5086C13.6869 26.0665 14.1091 25.7705 14.5931 25.54C14.6432 25.5158 15.256 25.2718 15.2524 25.2324C15.1719 24.4189 14.7371 23.8485 14.8642 22.9606C15.265 20.1607 18.0874 19.6665 19.9688 18.1194C20.6585 17.5526 21.2096 16.9903 21.6542 16.2073C22.0255 15.5544 21.9745 14.6226 22.8548 14.5203C23.0552 14.497 23.3665 14.5203 23.5499 14.5472C23.9793 14.61 24.415 14.7391 24.822 14.8853C26.1729 15.3705 27.6365 16.0871 28.481 17.2907C28.7306 17.6459 28.8988 18.0378 29.041 18.445C29.0768 18.5454 29.1367 19.0145 29.2101 19.0889C29.2879 19.1687 29.6476 19.1903 29.7218 19.1992C30.1852 19.2557 30.6611 19.2763 31.1138 19.4001C31.8644 19.6055 32.5335 20.3095 32.912 20.9678C33.3798 21.7822 33.5972 22.6629 33.514 23.6019C33.4809 23.9714 33.4469 24.1804 33.3637 24.5328C33.3432 24.6189 33.2188 24.7328 33.2886 24.7884C34.126 25.4503 35.1771 25.557 35.3337 26.8683C35.4151 27.5544 35.1977 28.2117 35.008 28.8602C34.8398 29.436 34.6896 30.0225 34.3818 30.5427C32.6973 33.3848 29.3103 34.0117 26.2713 34.0072C24.3542 34.0046 22.9461 33.9732 21.0745 33.3857",
    fill: "url(#paint0_linear_6598_9467)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0229 43.3841C17.9093 43.3841 16.9181 42.6784 16.5536 41.6262L12.5332 30.02L35.1146 30.02L32.2075 41.4168C31.9123 42.5742 30.8698 43.3841 29.6754 43.3841H19.0229Z",
    fill: "url(#paint1_linear_6598_9467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6598_9467",
    x1: 24.0975,
    y1: 4.98165,
    x2: 26.7828,
    y2: 87.1404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221154,
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6598_9467",
    x1: 26.6306,
    y1: 19.9399,
    x2: 20.2398,
    y2: 52.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281172,
    stopColor: "#FDA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754031,
    stopColor: "#FFC3F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCake);
export default __webpack_public_path__ + "static/media/BirthdayCake.0c85a8ffa1acb09677b33fc3931cf0bc.svg";
export { ForwardRef as ReactComponent };